import Image from 'next/image'

import { CostCalculation } from '@forms/CostCalculation'
import { CaseSection } from '@ui/cases/CaseSection'
import { HeaderSection } from '@ui/cases/HeaderSection'
import { TableSection } from '@ui/cases/TableSection'

import { config } from './config'
import { HeaderImageWrapper, Wrapper } from './styles'

export function DigitalTransformationCase() {
  return (
    <Wrapper>
      <HeaderSection
        marginTop="140px"
        title={config.titleTitleSection}
        image={
          <HeaderImageWrapper>
            <Image
              src={config.headerImagePath}
              title={config.headerImageAlt}
              alt={config.headerImageAlt}
              width={517}
              height={313}
              priority
            />
          </HeaderImageWrapper>
        }
      />
      <TableSection config={config.technologies} marginTop="45px" />
      <CaseSection
        title={config.titleClient}
        subtitle={config.subtitleClientSection}
        titlePosition="start"
        marginTop="120px"
        svgHexagonLocation={32}
        svgHexagon
      />
      <CaseSection
        title={config.titleChallengeSection}
        list={config.challengeSectionList}
        imageDetails={config.challengeImage}
        listWidth={640}
        marginTop="80px"
        subtitleMargin="0px"
      />
      <CaseSection
        title={config.titleSolution}
        list={config.solutionList}
        imageDetails={config.solutionImageDetail}
        marginTop="90px"
        subtitleMargin="0px"
        listWidth={600}
        hexagonMarker
      />
      <CaseSection
        title={config.titleResult}
        list={config.resultList}
        imageDetails={config.resultImages}
        marginTop="90px"
        subtitleMargin="32px"
        listWidth={640}
      />
      <CostCalculation />
    </Wrapper>
  )
}
